import { useNavigate } from 'react-router-dom';
import HataSayfasi, { HataButon } from './HataSayfasi';
import { IkonKalkan } from '../../components/Ikonlar';

export default function Page403() {
  const navigate = useNavigate();

  return (
    <HataSayfasi
      kod="403"
      renk="amber"
      ikon={<IkonKalkan size={40} />}
      baslik="Bu Sayfaya Yetkiniz Yok"
      aciklama={<>Bu bölümü görüntülemek için gereken yetki hesabınızda tanımlı değil. Yöneticinizden yetki isteyebilirsiniz.</>}
      altYazi="Yetkiler role göre verilir. Yönetici, Ayarlar → Roller sayfasından ilgili yetkiyi işaretleyerek erişim açabilir."
      aksiyonlar={
        <>
          <HataButon onClick={() => navigate(-1)}>← Geri Dön</HataButon>
          <HataButon birincil onClick={() => navigate('/')}>Ana Sayfa</HataButon>
        </>
      }
    />
  );
}
